import styled from 'styled-components';
import classNames from 'classnames';
import { BoxProps, Div } from '../box';
import { deviceSizes } from '../../style';
import { sizes, variants } from './style';

export interface PopoverContentContainerProps extends BoxProps {
  variant?: keyof typeof variants;
  size?: keyof typeof sizes;
  height?: string | number;
}

/**
 * A simple UI component - should be used in popover but can be used by other components that need to render some kind
 * of popover or a dropdown
 */
const PopoverContentContainer = styled(
  ({ variant, className, size, height, ...rest }: PopoverContentContainerProps) => (
    <Div className={classNames(variant, className, size)} {...rest} />
  ),
)`
  border-radius: 4px;
  z-index: 99999;

  width: ${props => sizes[props.size || 'sm']?.width};
  ${props => props.height && `height: ${typeof props.height === 'number' ? `${props.height}px` : props.height};`}

  ${props => variants[props.variant || 'default']};

  // Restrict the height of the content container to the available space on the screen
  max-height: calc(var(--radix-popover-content-available-height) - 8px);
  // and make it scrollable if content overflows
  overflow-y: ${props => props.overflowY || 'auto'};

  @media (max-width: ${deviceSizes.sm}) {
    min-width: max-content;
    width: 100%;
  }
`;

PopoverContentContainer.displayName = 'PopoverContentContainer';
export default PopoverContentContainer;
